import React from "react";
import { Box, Button, Card, TextField, Typography } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import DoneIcon from '@mui/icons-material/Done';

// common
import { dic } from "@common/text_defs"
import bgImage from "./imgs/bkgd-tech-stack.png";

const AbilitySection = () => {
  const itemList = [
    {
      title: dic.ability.front_end.title,
      value: dic.ability.front_end.desc,
    },
    {
      title: dic.ability.back_end.title,
      value: dic.ability.back_end.desc,
    },
    {
      title: dic.ability.algorithms.title,
      value: dic.ability.algorithms.desc,
    },
    {
      title: dic.ability.cloud.title,
      value: dic.ability.cloud.desc,
    },
  ]
  return (
    <Box component="section" className="section" id="ability" sx={{
      background: { sm: "url(./images/img_tech_stack.png) top center/cover no-repeat", xs: '#20408f' },
      mt: 3,
      py: { sm: 12, xs: 1 }
    }}>
      <Box className="container" sx={{}}>
        <Grid container spacing={2} sx={{
          justify: "space-between",
          alignItems: "center",
          ml: 1,
          py: { sm: 12, xs: 3 }
        }} >
          <Grid md={6} sm={6} xs={12} sx={{}}>
            <Box sx={{ fontWeight: 800, fontSize: '48px', color: "#6FCFF5", display: { xs: 'block', sm: 'none' } }}>
              {dic.ability.main_title}
            </Box>
            <Box sx={{
              mx: '8px',
              my: 5,
              maxWidth: { xs: '450px', sm: '450px' },
              color: '#ffffff',
              fontSize: '16px'
            }}>
              {dic.ability.sub_title}
            </Box>

            <Box sx={{ my: 2 }}>
              {itemList.map((item) => (
                <Box key={item.title} className="flex items-center" sx={{ my: '1em' }}>
                  <Box component="span" sx={{ mx: 1, minWidth: "8em", fontWeight: 600, color: "#73F6FC" }}>
                    {item.title}:
                  </Box>
                  <Box sx={{ fontWeight: 400, color: "#73F6FC" }}>
                    {item.value}
                  </Box>
                </Box>
              ))}
            </Box>
          </Grid>
          <Grid md={6} sm={6} sx={{ display: { sm: 'block', xs: 'none' } }}>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default AbilitySection;
export { AbilitySection };
